<style scope>
.sweet-modal.is-mobile-fullscreen .sweet-buttons {
  bottom: unset;
}
.radio-row {
  //float: left;
  //clear: none;
  display: inline-flex;
  line-height: 1.5;
  width: 100%;
}

label {
  //float: left;
  //clear: none;
  //display: block;
  padding: 0px 0.5em 0px 5px;
}

input[type=radio],
input.radio {
  //display: table-cell;
  //vertical-align: middle;
  //float: left;
  //clear: none;
  //margin: 2px 0 0 2px;
}
</style>

<template lang="pug">
  sweet-modal(:title="'Активировать пробный тариф для ' + email" ref="modal")
    slot
    button(slot="button" @click="close").btn.btn--small-fnt {{ cancelLabel }}
    button(v-promise-btn slot="button" @click="confirm").btn.btn--small-fnt.btn--accent {{ confirmLabel }}
</template>

<script>
import apiClient from '@/apiClient';

export default {
  name: 'TariffModal',
  props: {
    email: {
      required: true,
      type: String
    },
    firmId: {
      required: true,
      type: Number
    },
    confirmLabel: {
      required: false,
      type: String,
      default: 'Подтвердить'
    },
    cancelLabel: {
      required: false,
      type: String,
      default: 'Отменить'
    }
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    confirm() {
      return new Promise((resolve, reject) => {
        apiClient
          .put(`/firms/${this.firmId}/billings/tariff`, {
            id: 3
          })
          .then(response => {
            this.flashSuccess('Тариф активирован');
            this.$emit('confirm', this.firmId);
            this.close();
            resolve(response);
          })
          .catch(err => {
            this.flashError('Возникла ошибка');
            console.log(err);
            reject(err);
          });
      });
    }
  }
};
</script>
